export default __webpack_public_path__ + "static/media/014-art book.b4b68bb6.svg";